import { API as RestAPI } from "aws-amplify";
import { AppContextValue } from "../setup/context-value";
import { APIResponse, toDefaultRequestPayload } from "./common";

export interface DevOpsAPI {
    revokeUserPermissions(userId: string): Promise<APIResponse<string>>;
}

/**
 * DevOps API client. Server-side authorization is enforced in the Lambda handler
 * (DevOpsAPI in AskLegalLambda) via AuthorizationProxy.checkMemberOf — callers
 * must be altar-dev team members. The client-side admin check in DevOpsHome is
 * a UX gate only.
 */
export class DevOpsAPIImpl implements DevOpsAPI {
    constructor (private context: AppContextValue) {}

    async revokeUserPermissions(userId: string): Promise<APIResponse<string>> {
        const response: APIResponse<string> = await RestAPI.post(
            "custom-domain",
            "/devops/revoke-user-permissions",
            toDefaultRequestPayload({ userId })
        );
        return response;
    }
}
